// extracted by mini-css-extract-plugin
export var container = "_di-0";
export var popoverContent = "_di-1";
export var tosLink = "_di-2";